import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import Form from 'components/Form'
import Input from 'components/Form/Input'
import { required, not } from 'components/Form/validations'
import styled from 'styled-components/macro'
import { Body2 } from 'components/layout/text'
import { isTrackURL } from 'util/track'

const NoCode = styled(Body2).attrs({ emphasis: 'medium' })`
  text-align: center;
  margin-top: 1.6rem;
`

const CapsField = styled(Input.Tracking)`
  text-transform: uppercase;
`

class TrackForm extends Component {

  state = {
    tracking: null
  }


  handleData = data => {
    let { tracking } = data
    tracking = tracking.replace(/–/g, '')
    return new Promise(res => this.setState({ tracking }, res))
  }

  render() {

    if (this.state.tracking) {
      return <Redirect push to={`/${isTrackURL() && this.props.themeName ? `${this.props.themeName}/` : ''}id/${this.state.tracking}`} />
    }

    const validation = this.props.tracking ? not(this.props.tracking).withMessage('Please choose a different tracking number').required() : required

    return(
      <Form onData={this.handleData}>
        <Panel>
          <PanelHeading>Delivery Tracker</PanelHeading>
          <PanelSubheading>Enter your Tracking Number below to see minute by minute tracking!</PanelSubheading>

          <CapsField
            name="tracking"
            label="•••• – •••• – •••• – ••••"
            activeLabel="Tracking Number"
            validate={validation}
            defaultValue={this.props.tracking} />

          <Input.Submit>
            Track Now
          </Input.Submit>
          
        </Panel>

        <NoCode>Don’t have a tracking number?<br />You should be receiving an SMS or Email soon.</NoCode>
      </Form>
    )
  }
}

export default TrackForm